export default __webpack_public_path__ + "static/media/08.ca9d9e44.jpg";